import type { Comic } from "@/types/comic";

interface StatusBadgeProps {
  comic: Comic;
  className?: string;
}

export default function StatusBadge({ comic, className = "" }: StatusBadgeProps) {
  const isFinished = comic.status === "完结";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${
        isFinished
          ? "bg-secondary-100 text-secondary-900"
          : "bg-primary-100 text-primary-800"
      } ${className}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          isFinished ? "bg-secondary-500" : "bg-primary-500"
        }`}
      />
      {comic.status}
    </span>
  );
}